import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const CommentsIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue0b9'}</MuiIcon>
        );
    })